<div [@taskBookAnimation] id="wrap" *ngIf="taskBook">
    <div id="closeBtn">
        <span (click)="close()">×</span>
    </div>


  <div id="taskWrap" [innerHtml]="taskBook" class="fontSize16 lineHeight24">
        <!--<div class="fontSize24 taskbookTitle">-->
            <!--授权任务书-->
        <!--</div>-->
        <!--<div class="fontSize16 lineHeight24 taskbookContent">-->
          <!--<p>未来智播间</p>-->
          <!--<p>&nbsp;</p>-->
          <!--<p>关键词：<span>行业专家 智能科技 前沿趋势</span></p>-->
          <!--<p>形式：<span>每月一次，在线直播</span></p>-->
          <!--<p>宣传预算：<span>5万/期</span></p>-->
          <!--<p>指标：</p>-->
          <!--<span class="changeLineSpan">前三期：5000+独立访客/期，</span>-->
          <!--<span class="changeLineSpan">一年内: 平均30000+独立访客/期</span>-->
          <!--<p>负责人选要求：</p>-->
          <!--<span class="changeLineSpan">1.有创意，能将专业内容包装成妙趣横生</span>-->
          <!--<span class="changeLineSpan">、适合消费者口味的话题。</span>-->
          <!--<span class="changeLineSpan">2.沟通能力强。</span>-->
        <!--</div>-->
    </div>

    <div id="text" class="fontSize18">
        <b>这个任务，你会交给谁？</b>
    </div>

    <div id="startBtn" class="fontSize18" (click)="goToNextStep()">
        开始任务
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-begin/case-practice-authorization-begin.component.html